// Shared UI for the Weight/Body sub-tabs.

export function BodyStat({
  label,
  value,
  unit,
  accent,
}: {
  label: string;
  value: string | number | null | undefined;
  unit?: string;
  accent?: boolean;
}) {
  const show = value != null && value !== "";
  return (
    <div className="rounded-md border border-ink-line bg-canvas px-2 py-2 text-center">
      <div className="text-[10px] uppercase tracking-wider text-ink-subtle">{label}</div>
      <div className={`mt-0.5 font-display text-lg tabular-nums ${accent ? "text-accent" : "text-ink"}`}>
        {show ? value : "—"}
      </div>
      {show && unit && <div className="text-[10px] text-ink-subtle">{unit}</div>}
    </div>
  );
}

/** Signed kg delta with a direction arrow. Neutral colour — down isn't always
 *  "good" (someone may be gaining on purpose). */
export function Delta({ kg, suffix }: { kg: number | null | undefined; suffix?: string }) {
  if (kg == null) return <span className="text-ink-subtle">—</span>;
  const arrow = kg < 0 ? "▼" : kg > 0 ? "▲" : "·";
  const sign = kg > 0 ? "+" : "";
  return (
    <span className="tabular-nums text-ink-muted">
      {arrow} {sign}
      {kg.toFixed(1)} kg{suffix ? ` ${suffix}` : ""}
    </span>
  );
}
